import { Component } from '@angular/core';
import { Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms';


@Component({
    selector: "form-group",
    templateUrl: './formGroup.component.html',
    inputs: ["icon_left", "icon_right", "text_left", "text_right", "label"],
})
export class FormGroupComponent {



}


@Component({
    selector: "form-group-metronic",
    templateUrl: './formGroup.component.1.html',
    inputs: ["icon_left", "icon_right", "text_left", "text_right", "label"],
})
export class FormGroupMetronicComponent {

}

@Component({
    selector: "form-field-error",
    templateUrl: './formGroupError.component.html',
    inputs: ["icon"],
})


export class FormGroupErrorComponent {

}









// WEBPACK FOOTER //
// ./src/app/theme/layouts/custom-component/FormGroupComponent.ts